/**
 * Page + PageHeader — the outer frame of every migrated screen.
 *
 * <Page> lays a screen's children out as a vertical stack with consistent gaps.
 *
 * <PageHeader> is the title row:
 *   [title  · count/subtitle]                     [extra]  [primary action]
 *
 * Props (PageHeader):
 *   title     string         page title, e.g. "לקוחות"
 *   subtitle  node           small gray text next to the title (e.g. "1,240 תוצאות")
 *   actions   node           buttons on the far side (primary action last)
 *
 * Usage:
 *   <Page>
 *     <PageHeader title="לקוחות" subtitle="12 תוצאות" actions={<Button type="primary">…</Button>} />
 *     <FilterBar … />
 *     <DataTable … />
 *   </Page>
 */
import React from 'react';
import styles from './Page.css';

export const Page = ({ children, className }) => (
  <div className={[styles.page, className].filter(Boolean).join(' ')}>{children}</div>
);

export const PageHeader = ({ title, subtitle, actions }) => (
  <div className={styles.header}>
    <div className={styles.titleGroup}>
      <h1 className={styles.title}>{title}</h1>
      {subtitle ? <span className={`${styles.subtitle} ui-tabular`}>{subtitle}</span> : null}
    </div>
    {actions ? <div className={styles.actions}>{actions}</div> : null}
  </div>
);

export default Page;
